import api from './api';

export interface FileDefinition {
  _id: string;
  name: string;
  fileType: 'CSV' | 'JSON' | 'XML' | 'Parquet' | 'Avro' | 'Excel' | 'Text' | 'Binary' | 'Other';
  schema?: string;
  description?: string;
  samplePath?: string;
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateFileDefinition {
  name: string;
  fileType: 'CSV' | 'JSON' | 'XML' | 'Parquet' | 'Avro' | 'Excel' | 'Text' | 'Binary' | 'Other';
  schema?: string;
  description?: string;
  samplePath?: string;
  order?: number;
  isActive?: boolean;
}

export interface UpdateFileDefinition extends Partial<CreateFileDefinition> {}

const base = '/file-definitions';

const fileDefinitionsService = {
  async list(q?: string): Promise<FileDefinition[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as FileDefinition[];
  },
  async create(payload: CreateFileDefinition): Promise<FileDefinition> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as FileDefinition;
  },
  async update(id: string, payload: UpdateFileDefinition): Promise<FileDefinition> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as FileDefinition;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default fileDefinitionsService;
